<div style="width: 25px;height: 25px;float: right;position: relative;right: -10px;cursor: pointer;"
     (click)="closeModal()">
  <i class="material-icons icon" style="font-size: 30px;color: #c80000">
    cancel
  </i>
</div>
<mat-dialog-content novalidate style="max-height: 80vh;overflow-y: auto;padding: 0 !important">

  <form [formGroup]="employeeAddForm">
    <mat-tab-group>
      <mat-tab label="Genel">
       
        <div formGroupName="employeeGenel">
          <div class="row" style="padding-top: 15px;" >
            <div class="col-sm-6">
              <div class="profile-photo-wrapper" *ngIf="operationName == 'CREATE'">
                <img class="profile-photo" *ngIf="operationName == 'CREATE'" alt=" " src="{{fileNameData.fileBase64}}">
                <span *ngIf="fileNameData.fileBase64 == null" class="profile-photo-span">Profil Fotosu Yükle</span>
                <input #profilePhotoInput class="profile-photo-input" type="file" (change)="fileProgress($event)">
                <button *ngIf="fileNameData.fileBase64 != null"
                        class="btn btn-info profile-photo-delete-btn"
                        (click)="deleteProfilePhoto()">
                  Sil
                </button>
              </div>
              <div class="profile-photo-wrapper" *ngIf="operationName == 'UPDATE'">
                <img class="profile-photo" *ngIf="filePath != null && !isImageChanged" alt=" " src="{{fileUploadRoot}}/{{filePath}}">
                <img class="profile-photo" *ngIf="isImageChanged" alt=" " src="{{fileNameData.fileBase64}}">
                <span *ngIf="fileNameData.fileBase64 == null && filePath == null" class="profile-photo-span">Profil Fotosu Yükle</span>
                <input #profilePhotoInput2 class="profile-photo-input" type="file" (change)="fileProgress($event)">
                <button *ngIf="fileNameData.fileBase64 != null || filePath != null"
                        class="btn btn-info profile-photo-delete-btn" (click)="deleteProfilePhoto()">
                  Sil
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field class="form-element">
                  <input matInput placeholder="Ad" formControlName="name">
                  <mat-error *ngIf="employeeAddForm.controls.employeeGenel.get('name').hasError('required')">Ad
                    girmelisiniz</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field class="form-element">
                  <input matInput placeholder="Soyad" formControlName="surname">
                  <mat-error *ngIf="employeeAddForm.controls.employeeGenel.get('surname').hasError('required')">Soyad
                    girmelisiniz</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field class="form-element">
                  <mat-label>Doğum Tarihi</mat-label>
                  <input readonly matInput [matDatepicker]="pickerbd" formControlName="birthDate"
                    placeholder="Doğum Tarihi">
                  <mat-datepicker-toggle matSuffix [for]="pickerbd"></mat-datepicker-toggle>
                  <mat-datepicker #pickerbd></mat-datepicker>
                </mat-form-field>
                <mat-error *ngIf="employeeAddForm.controls.employeeGenel.get('birthDate').hasError('required')">Doğum Tarihi
                  girmelisiniz</mat-error>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field class="form-element">
                  <mat-label>Cinsiyet </mat-label>
                  <mat-select formControlName="gender" >
                      <mat-option *ngFor="let gender of genderList" [value]="gender.lookupValue" >
                          {{gender.description}}
                      </mat-option>
                  </mat-select>
                  <mat-error *ngIf="employeeAddForm.controls.employeeGenel.get('gender').hasError('required')">Cinsiyet seçiniz</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field class="form-element">
                  <input type="text" matInput placeholder="Telefon" formControlName="gsm" maxlength="17">
                  <mat-error *ngIf="employeeAddForm.controls.employeeGenel.get('gsm').errors">
                    Telefon rakamları eksik veya fazla
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field class="form-element">
                  <input matInput placeholder="Email" formControlName="email">
                  <mat-error *ngIf="employeeAddForm.controls.employeeGenel.get('email').hasError('required')">Email
                    girmelisiniz</mat-error>
                  <mat-error *ngIf="employeeAddForm.controls.employeeGenel.get('email').hasError('email')">Email formatı
                    hatalı</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field class="form-element">
                  <input type="text" matInput placeholder="Yemek Kart No" formControlName="mealCardNo" maxlength="20">
               
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field class="form-element">
                  <input type="text" matInput placeholder="Personel Sicil No" formControlName="personalNo" maxlength="20">
                  </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <mat-form-field class="form-element">
                  <input matInput placeholder="Tckno" formControlName="tckn"  maxlength="11">
                  <mat-error *ngIf="employeeAddForm.controls.employeeGenel.get('tckn').errors">Tckno
                    doğru formatta olmalı ve zorunludur</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <!-- <mat-form-field class="lookup-form-field">
            <input placeholder="İşe Giriş Tarihi" aria-label="Number"
                   formControlName="startofdate" matInput
                   #datepickerDMY="bsDatepicker" bsDatepicker
                   [bsConfig]="bsConfig">


            <mat-error *ngIf="employeeAddForm.controls['startofdate'].hasError('required')">İşe giriş tarihi seçiniz</mat-error>
        </mat-form-field> -->

                <mat-form-field>
                  <mat-label>İşe Giriş Tarihi</mat-label>
                  <input readonly matInput [matDatepicker]="picker" formControlName="startofdate"
                    placeholder="İşe Giriş Tarihi">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <mat-error *ngIf="employeeAddForm.controls.employeeGenel.get('startofdate').hasError('required') &&
                                  (employeeAddForm.controls.employeeGenel.get('startofdate').dirty ||
                                   employeeAddForm.controls.employeeGenel.get('startofdate').touched)">İşe
                  giriş tarihi seçiniz</mat-error>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <mat-form-field>
                  <mat-label>İşten Çıkış Tarihi</mat-label>
                  <input readonly matInput [matDatepicker]="pickerend" formControlName="endofdate"
                    placeholder="İşten Çıkış Tarihi">
                  <mat-datepicker-toggle matSuffix [for]="pickerend"></mat-datepicker-toggle>
                  <mat-datepicker #pickerend></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field>
                  <mat-label>Üst Departman</mat-label>
                  <mat-select formControlName="parentDepartmentId">
                    <mat-option *ngFor="let department of parentDepartmentList" [value]="department.id">
                      {{department.lookupValue}} - {{department.description}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="(employeeAddForm.controls.employeeGenel.get('parentDepartmentId').hasError('required') &&
                                    (employeeAddForm.controls.employeeGenel.get('parentDepartmentId').dirty ||
                                     employeeAddForm.controls.employeeGenel.get('parentDepartmentId').touched))">
                    Üst Departman Seçiniz
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field>
                  <mat-label>Departman</mat-label>
                  <mat-select formControlName="departmentId" [disabled]="!employeeAddForm.controls.employeeGenel.get('parentDepartmentId').value">
                    <mat-option *ngFor="let department of filteredDepartmentList" [value]="department.id">
                      {{department.lookupValue}} - {{department.description}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="(employeeAddForm.controls.employeeGenel.get('departmentId').hasError('required') &&
                                    (employeeAddForm.controls.employeeGenel.get('departmentId').dirty ||
                                     employeeAddForm.controls.employeeGenel.get('departmentId').touched))">
                    Departman Seçiniz
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <mat-form-field>
                  <mat-label>Ünvan</mat-label>
                  <mat-select formControlName="titleId">
                    <mat-option *ngFor="let title of titleList" [value]="title.id">
                      {{title.lookupValue}} - {{title.description}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="(employeeAddForm.controls.employeeGenel.get('titleId').hasError('required') &&
                                    (employeeAddForm.controls.employeeGenel.get('titleId').dirty ||
                                     employeeAddForm.controls.employeeGenel.get('titleId').touched))">
                    Ünvan Seçiniz
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <mat-form-field style="width: 100%">
                  <input type="text" placeholder="Yönetici Seçiniz" aria-label="Number" matInput
                         formControlName="managerId" [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let manager of filteredManagerList | async" [value]="manager">
                      {{manager.name + " " + manager.surname}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="employeeAddForm.controls.employeeGenel.get('managerId').hasError('incorrect')">
                    Yönetici Seçiniz
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <mat-form-field style="width: 100%">
                  <input type="text" placeholder="Onay Yöneticisi Seçiniz" aria-label="Number" matInput
                         formControlName="approvalManagerId" [matAutocomplete]="autoApproval">
                  <mat-autocomplete #autoApproval="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let approvalManager of filteredApprovalManager | async" [value]="approvalManager">
                      {{approvalManager.name + " " + approvalManager.surname}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="employeeAddForm.controls.employeeGenel.get('approvalManagerId').hasError('incorrect')">
                    Onay Yöneticisi Seçiniz
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <button type="submit" class="btn btn-primary" [disabled]="!employeeAddForm.controls.employeeGenel.valid" (click)="createOrUpdateEmployee()">Kaydet</button>
        </div>
      </mat-tab>
      <mat-tab *ngIf="operationName == 'UPDATE' " label="İdari">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group idari-title">Çalışılmayan Dönem</div></div></div>
        
        <div formGroupName="employeeIdari">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field>
                  <mat-label>Başlangıç Tarihi</mat-label>
                  <input readonly matInput [matDatepicker]="picker1" formControlName="startdate" aria-label="Number"
                    placeholder="Başlangıç Tarihi">
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
                <mat-error *ngIf="employeeAddForm.controls.employeeIdari.get('startdate').hasError('required')">İşe
                  giriş tarihi seçiniz</mat-error>

              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field>
                  <mat-label>Bitiş Tarihi</mat-label>
                  <input readonly matInput [matDatepicker]="picker2" formControlName="enddate" aria-label="Number"
                    placeholder="Bitiş Tarihi">
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
                <mat-error *ngIf="employeeAddForm.controls.employeeIdari.get('enddate').hasError('required')">İşe giriş
                  tarihi seçiniz</mat-error>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field style="width: 100%">
                  <mat-label>Açıklama</mat-label>
                  <textarea class="idari-description-textarea" matInput formControlName="description"
                    aria-label="Number" placeholder="Açıklama" maxlength="250"></textarea>
                  <mat-error *ngIf="employeeAddForm.controls.employeeIdari.get('description').hasError('required')">
                    Açıklama giriniz</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group">
              <div class="col-sm-12" style="text-align: right;">
                <button class="btn btn-primary" (click)="createEmployeeIdari()"
                        [disabled]="!employeeAddForm.valid ||
                                    employeeAddForm.controls.employeeIdari.get('description').value.trim() == ''">Ekle</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
           
              <mat-table class="lessons-table mat-elevation-z8" [dataSource]="dsemployeeIdari" style="width: 100%">

                <ng-container matColumnDef="effectiveStartDate">
                  <mat-header-cell *matHeaderCellDef> Başlangıç Tarihi </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.effectiveStartDate}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="effectiveEndDate">
                  <mat-header-cell *matHeaderCellDef> Bitiş Tarihi </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.effectiveEndDate}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="explanation">
                  <mat-header-cell *matHeaderCellDef style="flex-grow: 1.5;"> Açıklama </mat-header-cell>
                  <mat-cell *matCellDef="let element"
                            style="flex-grow: 1.5;"> {{element.explanation}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef style="flex-grow: 0.5;"></mat-header-cell>
                  <mat-cell *matCellDef="let element" style="justify-content: end;flex-grow: 0.5;">
                    <button mat-icon-button matTooltip="Click to Delete" class="iconbutton" color="primary"
                      (click)="openDeleteModal(element)">
                      <mat-icon aria-label="delete">delete_forever</mat-icon>
                    </button>
                  </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

              </mat-table>
              <mat-paginator [pageSizeOptions]="[10, 20, 50,100]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab *ngIf="operationName == 'UPDATE' " label="İzin Raporu">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group report-title">İzin Dökümü</div></div></div>
            <div formGroupName="employeeAbsReportForm">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <mat-form-field>
                      <mat-label>Başlangıç Tarihi</mat-label>
                      <input readonly matInput [matDatepicker]="picker11" formControlName="repstart" aria-label="Number"
                        placeholder="Başlangıç Tarihi">
                      <mat-datepicker-toggle matSuffix [for]="picker11"></mat-datepicker-toggle>
                      <mat-datepicker #picker11></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <mat-form-field>
                      <mat-label>Bitiş Tarihi</mat-label>
                      <input readonly matInput [matDatepicker]="picker22" formControlName="repend" aria-label="Number"
                        placeholder="Bitiş Tarihi">
                      <mat-datepicker-toggle matSuffix [for]="picker22"></mat-datepicker-toggle>
                      <mat-datepicker #picker22></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group">
                <div class="col-sm-12" style="text-align: left;">
                  <button class="btn btn-primary" (click)="getAbsReport()">Rapor Al</button>
                </div>
              </div>
            </div>
      </mat-tab>
    </mat-tab-group>
  </form>
  <!-- bitis -->
</mat-dialog-content>
<div mat-dialog-actions align="end">
</div>
